export default __webpack_public_path__ + "static/media/mx 1.564dfab5.webp";